import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class DiscountsService {

  constructor(
    private api: ApiService
  ) { }

  getByCode(code: string): any {
    return this.api.get('/coupons/codes/'+code);
  }
}
